<ng-container *ngIf="rejectionComment">
	<div class="row">
		<div class="col-12">
			<div class="alert alert-danger" id="rejectionComment">
				<span class="text-break"><i class="fas fa-exclamation-circle m-r-sm"></i> {{rejectionComment}}</span>
			</div>
		</div>
	</div>
</ng-container>